import { mergePublicPhases } from "./publicTimelineState";

function liveStep(row) {
  return {
    id: row.id,
    label: row.label,
    status: row.status,
    origin_run_id: row.originRunId ?? null,
    started_seq: row.startedSeq ?? null,
    last_seq: row.lastSeq ?? null,
    started_at: row.startedAt ?? null,
    finished_at: row.finishedAt ?? null,
  };
}

function byStep(a, b) {
  return (
    (a.started_seq ?? Number.MAX_SAFE_INTEGER) -
    (b.started_seq ?? Number.MAX_SAFE_INTEGER)
  );
}

export function publicTimelineView({
  phases = [],
  historySteps = [],
  activity = [],
}) {
  const steps = new Map(historySteps.map((row) => [row.id, row]));
  activity.forEach((row) =>
    steps.set(row.id, { ...steps.get(row.id), ...liveStep(row) }),
  );
  const rows = [...steps.values()].sort(byStep);
  const visiblePhases = mergePublicPhases([], phases).map((phase) => ({
    ...phase,
    rows: phase.activity_ids.map((id) => steps.get(id)).filter(Boolean),
  }));
  const assigned = new Set(
    visiblePhases.flatMap((phase) => phase.activity_ids),
  );
  return {
    phases: visiblePhases,
    orphans: rows.filter((row) => !assigned.has(row.id)),
  };
}
